import texts from "./du";
import countriesAndRegions from "./countriesAndRegions";
import crops from "./crops";
import products from "./products";

const du = { ...texts, ...countriesAndRegions, ...crops, ...products };

export default du;
